export default Object.freeze({
  TASK_MESSAGE_MANAGE: '업무메시지 관리',
  ORDER_NO: '주문번호',
  REGISTER_ADMIN_NAME: '등록자명',
  COMPLETED_ADMIN_NAME: '처리자명',
  REGISTRATION_DATE: '등록일시',
  STATE: '상태',
  PROCESSING: '처리중',
  DONE: '완료',
  TYPE: '유형',
  ORDER_PRODUCT: '주문상품',
  DELIVERY: '배송',
  CANCEL_CHANGE_REFUND: '취소/교환/반품',
  REFUND: '환불',
  ETC: '기타',
  CONTENT: '내용',
  SELECT_MESSAGE_TYPE: '업무메시지 유형을 선택해주세요',
})